(function() {
	'use strict';

	angular.module('app.dashboard')
	.config(leanProjectTaskSummaryConfig);


	function leanProjectTaskSummaryConfig (dashboardProvider) {
		// register widget
		dashboardProvider.widget(
			'leanProjectTaskSummary', {
				name: 'Task Progress Summary by Due Date',
				description: 'A visual summary of how lean project tasks are progressing',
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/Task-Progress-Summary-by-Due-Date.png',
				categories: ['All', 'Lean Projects'],
				config: {},
				slideshowView: true,
				isActive: true,
				controller: 'leanProjectTaskSummaryCtrl',
				templateUrl: '/application/f/dashboard/widgets/lean-project-task-summary.html',
				reload: true,
				isDrillDown: false
			}
		);
	}
})();
